import { APIBinderData, APIQuoteVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processQuoteDetailsData = (
  binderReportData: APIBinderData,
): BinderSectionData => {
  const quoteData = binderReportData.quote_data;
  const quoteMessages = quoteData?.policy.msg;
  const vehicles: {
    name: string;
    messages: string[];
    deductables: string[];
  }[] = [];

  quoteData.vehicles.forEach((vehicle: APIQuoteVehicle) => {
    vehicles.push({
      name: vehicle.name,
      messages: vehicle.msg,
      deductables: vehicle.dis,
    });
  });

  return {
    title: 'Quote Details',
    description: '',
    isValid: true,
    message: undefined,
    data: {
      messages: quoteMessages,
      vehicles,
    },
  };
};
